import { CutoffTimesModel, Weekdays } from '@src/models/config-models';
import { fromPairs } from 'ramda';

export const defaultCutoffTimes: CutoffTimesModel = fromPairs(
  Object.values(Weekdays).map(day => [day, { times: ['00:00'] }])
);
